import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35592d44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-full-view-menu-button" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Menu")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Terms of Service")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chevron_icon = _resolveComponent("chevron-icon")!
  const _component_base_typography = _resolveComponent("base-typography")!
  const _component_toolbar_row_button = _resolveComponent("toolbar-row-button")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_base_button_icon = _resolveComponent("base-button-icon")!
  const _component_profile_card = _resolveComponent("profile-card")!
  const _component_dashboard_icon = _resolveComponent("dashboard-icon")!
  const _component_side_menu_item = _resolveComponent("side-menu-item")!
  const _component_calendar_icon = _resolveComponent("calendar-icon")!
  const _component_mail_icon = _resolveComponent("mail-icon")!
  const _component_biometrics_icon = _resolveComponent("biometrics-icon")!
  const _component_biometrics_menu_items = _resolveComponent("biometrics-menu-items")!
  const _component_test_results_icon = _resolveComponent("test-results-icon")!
  const _component_document_icon = _resolveComponent("document-icon")!
  const _component_line_graph_icon = _resolveComponent("line-graph-icon")!
  const _component_gear_icon = _resolveComponent("gear-icon")!
  const _component_account_settings_menu_items = _resolveComponent("account-settings-menu-items")!
  const _component_question_icon = _resolveComponent("question-icon")!
  const _component_note_icon = _resolveComponent("note-icon")!
  const _component_terms_of_service_body_text = _resolveComponent("terms-of-service-body-text")!
  const _component_base_modal = _resolveComponent("base-modal")!
  const _component_logout_icon = _resolveComponent("logout-icon")!
  const _component_base_side_menu = _resolveComponent("base-side-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_toolbar_row_button, {
      onClick: _cache[0] || (_cache[0] = () => _ctx.toggleMenu())
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", null, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_chevron_icon, { class: "sidebar-menu-chevron-icon" }),
            _createVNode(_component_base_typography, { h4: "" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_base_side_menu, {
      isOpen: _ctx.isMenuOpen,
      onClose: _ctx.toggleMenu,
      class: "toolbar-side-menu"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_base_button_icon, {
          class: "close-button",
          transparent: "",
          onClick: _cache[1] || (_cache[1] = () => _ctx.toggleMenu())
        }, {
          default: _withCtx(() => [
            _createVNode(_component_close_icon)
          ]),
          _: 1
        }),
        _createVNode(_component_profile_card),
        _createVNode(_component_side_menu_item, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToMenuItem(_ctx.Routes.dashboard)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_dashboard_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.dashboardTitle), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_side_menu_item, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToMenuItem(_ctx.Routes.appointments)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_calendar_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.appointmentsTitle), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_side_menu_item, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToMenuItem(_ctx.Routes.messages)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_mail_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.messagesTitle), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_side_menu_item, {
          onClick: _ctx.toggleBiometricsListItems,
          showNestedList: _ctx.isBiometricsListOpen
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_biometrics_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.biometricsTitle), 1)
          ]),
          "nested-list": _withCtx(() => [
            _createVNode(_component_biometrics_menu_items, { onGoToRoute: _ctx.goToMenuItem }, null, 8, ["onGoToRoute"])
          ]),
          _: 1
        }, 8, ["onClick", "showNestedList"]),
        _createVNode(_component_side_menu_item, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToMenuItem(_ctx.Routes.testResults)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_test_results_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.testResultsTitle), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_side_menu_item, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToMenuItem(_ctx.Routes.patientDocuments)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_document_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.patientDocumentsTitle), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_side_menu_item, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToMenuItem(_ctx.Routes.patientChartsMedicalHistory)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_line_graph_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.patientChartsTitle), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_side_menu_item, {
          onClick: _ctx.toggleAccountSettingsListItems,
          showNestedList: _ctx.isAccountSettingsListOpen
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_gear_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.accountSettingsTitle), 1)
          ]),
          "nested-list": _withCtx(() => [
            _createVNode(_component_account_settings_menu_items, { onGoToRoute: _ctx.goToMenuItem }, null, 8, ["onGoToRoute"])
          ]),
          _: 1
        }, 8, ["onClick", "showNestedList"]),
        _createVNode(_component_side_menu_item, { onClick: _ctx.goToReportIssuePage }, {
          icon: _withCtx(() => [
            _createVNode(_component_question_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.helpTitle), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_side_menu_item, { onClick: _ctx.toggleTermsOfService }, {
          icon: _withCtx(() => [
            _createVNode(_component_note_icon)
          ]),
          title: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_base_modal, {
          isOpen: _ctx.isTermsOfServiceOpen,
          title: "Terms of Service",
          largeModal: true,
          clickOutsideToClose: true,
          onClose: _ctx.toggleTermsOfService
        }, {
          default: _withCtx(() => [
            _createVNode(_component_terms_of_service_body_text)
          ]),
          _: 1
        }, 8, ["isOpen", "onClose"]),
        _createVNode(_component_side_menu_item, {
          class: "logout",
          onClick: _ctx.logout
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_logout_icon)
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.logoutTitle), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["isOpen", "onClose"])
  ], 64))
}